export default __webpack_public_path__ + "static/media/purchasefailure.ea27383e.svg";